export var IcebergRestCatalogAuthType;
(function (IcebergRestCatalogAuthType) {
    IcebergRestCatalogAuthType["ICEBERG_REST_CATALOG_AUTH_TYPE_NONE"] = "NONE";
    IcebergRestCatalogAuthType["ICEBERG_REST_CATALOG_AUTH_TYPE_BASIC_AUTH"] = "BASIC_AUTH";
    IcebergRestCatalogAuthType["ICEBERG_REST_CATALOG_AUTH_TYPE_OAUTH2_BEARER_TOKEN"] = "OAUTH2_BEARER_TOKEN";
    IcebergRestCatalogAuthType["ICEBERG_REST_CATALOG_AUTH_TYPE_OAUTH2_CLIENT_CREDENTIALS"] = "OAUTH2_CLIENT_CREDENTIALS";
})(IcebergRestCatalogAuthType || (IcebergRestCatalogAuthType = {}));
